import { render } from "./RollupBuilder.vue?vue&type=template&id=6da19f9a&ts=true"
import script from "./RollupBuilder.vue?vue&type=script&lang=ts"
export * from "./RollupBuilder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__